"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartJS = void 0;
const React = require("react");
const auto_1 = require("chart.js/auto");
const chartjs_plugin_datalabels_1 = require("chartjs-plugin-datalabels");
const chart_utils_1 = require("./chart.utils");
const constants_1 = require("../../utils/constants");
exports.ChartJS = React.forwardRef((props, ref) => {
    const { title = '', id, type, data, width = '700px', height = 'auto', dataLabels = false, maintainProportions = true, options, } = props;
    auto_1.default.register(chartjs_plugin_datalabels_1.default);
    auto_1.default.defaults.color = '#004666';
    auto_1.default.defaults.font.size = 15;
    const canvasStyle = {
        backgroundColor: '#f2f2f2',
    };
    const chartRef = React.useRef(null);
    const [chart, setChart] = React.useState();
    React.useImperativeHandle(ref, () => chart, [chart]);
    const destroyChart = () => {
        if (chart) {
            chart.destroy();
        }
    };
    const renderChart = () => {
        destroyChart();
        const _a = options || {}, { plugins } = _a, opt = __rest(_a, ["plugins"]);
        setChart(new auto_1.default(chartRef.current, {
            type,
            data,
            options: Object.assign({ responsive: true, maintainAspectRatio: maintainProportions, events: [
                    'mousemove',
                    'mouseout',
                    'click',
                    'touchstart',
                    'touchmove',
                ], plugins: Object.assign(Object.assign({}, plugins), { title: {
                        display: true,
                        text: title ? title : '',
                        font: {
                            size: 20,
                        },
                        align: 'start',
                        padding: {
                            bottom: type === 'pie' || type === 'doughnut'
                                ? constants_1.zero
                                : constants_1.thirty,
                        },
                    }, datalabels: {
                        display: dataLabels,
                        align: 'end',
                        anchor: 'end',
                    }, tooltip: {
                        callbacks: {
                            label: (context) => (0, chart_utils_1.getLabel)(context),
                        },
                    } }) }, opt),
        }));
    };
    React.useEffect(() => {
        renderChart();
        return () => {
            destroyChart();
        };
    }, [props, chartRef.current]);
    return (React.createElement("div", { style: { position: 'relative', width, height, margin: 'auto' } },
        React.createElement("canvas", { ref: chartRef, style: canvasStyle, id: id })));
});
